import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IGetViewerControlledThemeParams {
}

export interface IGetViewerControlledThemeResult extends IResult {
    viewerControlledTheme: number;
}

export class GetViewerControlledThemeRequest extends Request<IGetViewerControlledThemeParams, IResult> {
    constructor(params: IGetViewerControlledThemeParams) {
        super('getViewerControlledTheme', params);
    }
}
